import { Context, createContext } from 'react'
import { DefaultConfig } from './defaultConfig'

const contextKey = '__FIREBASE_CONFIG_CONTEXT__'

export type ConfigContextValue = {
    config: DefaultConfig
    loading: boolean
}

export const getConfigContext = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let context = (createContext as any)[contextKey] as Context<ConfigContextValue>

    if (!context) {
        context = createContext({} as ConfigContextValue)
        Object.defineProperty(createContext, contextKey, {
            value: context,
            enumerable: false,
            writable: false,
            configurable: true,
        })

        context.displayName = 'ConfigContext'
    }

    return context
}
